/**
 * @generated SignedSource<<479b295625136c6925197a3843e5f020>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type IntegratePageQuery$variables = {
  useDesktop?: boolean | null;
  useExtension?: boolean | null;
};
export type IntegratePageQuery$data = {
  readonly users: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
      };
    }>;
  } | null;
};
export type IntegratePageQuery = {
  response: IntegratePageQuery$data;
  variables: IntegratePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useDesktop"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useExtension"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 20
      },
      {
        "kind": "Variable",
        "name": "hasUsedBrowserExtension",
        "variableName": "useExtension"
      },
      {
        "kind": "Variable",
        "name": "hasUsedDesktopApp",
        "variableName": "useDesktop"
      }
    ],
    "concreteType": "UserConnection",
    "kind": "LinkedField",
    "name": "users",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegratePageQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "IntegratePageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2cdf2ed68f0245788ea01c5333b72906",
    "id": null,
    "metadata": {},
    "name": "IntegratePageQuery",
    "operationKind": "query",
    "text": "query IntegratePageQuery(\n  $useExtension: Boolean\n  $useDesktop: Boolean\n) {\n  users(first: 20, hasUsedBrowserExtension: $useExtension, hasUsedDesktopApp: $useDesktop) {\n    edges {\n      node {\n        id\n        firstName\n        fullName\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4b755e8f79a3177d907a6609e96ad123";

export default node;
